import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme, { ThemeType } from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  title: string;
  description: string;
  icon: any;
  theme: ThemeType;
  onPress?(): void;
}

export const LongTermGoalInfoSection = ({ icon, title, description, theme }: IProps) => {
  const color = theme === ThemeType.dark ? Theme.WHITE : Theme.CHARCOAL;
  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View style={styles.leftContainer}>
          {icon}
        </View>
        <View style={styles.textContainer}>
          <Text style={[styles.title, { color }]}>{title.toUpperCase()}</Text>
        </View>
      </View>
      <View style={styles.innerContainer}>
        <View style={styles.leftContainer}></View>
        <View style={styles.textContainer}>
          <Text style={[styles.description, { color }]}>{description}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: defaultScale(20),
  },
  innerContainer: {
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'center',
  },
  leftContainer: {
    flex: 0.1,
  },
  textContainer: {
    flex: 0.9,
    paddingLeft: defaultScale(10),
  },
  title: {
    ...Theme.textStyle.heading2,
    color: Theme.WHITE,
    paddingBottom: defaultScale(5),
  },
  description: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
  },
});
